import React from 'react'
import { useSublocation, useEditSublocation, SubLocation } from '@modmd/data'
import { SelectInput } from 'components/SelectInput'
import { OptionType } from 'components/SelectInput/SelectInput'

interface Props {
  sublocation: string
  sessionId?: string
  refetch: () => void
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void
  isDisabled?: boolean
}

export const Sublocation: React.FC<Props> = ({
  sublocation,
  sessionId,
  refetch,
  onChange,
  isDisabled = false,
}) => {
  const { data } = useSublocation()
  const [editSublocation] = useEditSublocation({
    onCompleted: () => {
      refetch()
    },
  })

  return (
    <SelectInput
      name="sublocation"
      label="Rate type"
      value={sublocation}
      options={
        (data?.sublocations.map((loc) => ({
          value: loc.name,
          label: loc.displayName,
        })) as OptionType[]) || []
      }
      onChange={(event) => {
        if (onChange) void onChange(event)
        if (sessionId) {
          void editSublocation({
            variables: {
              id: sessionId,
              sublocation: event.target.value as SubLocation,
            },
          })
        }
      }}
      disabled={isDisabled}
    />
  )
}
